import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { CsvDownloadButtonComponent } from "./csv-download-button.component";

@NgModule({
  declarations: [CsvDownloadButtonComponent],
  imports: [CoreModule, DirectivesModule],
  exports: [CsvDownloadButtonComponent],
})
export class CsvDownloadButtonModule {}
